import wishlist from './wishlist'

export default [
  
  {
    path: '',
    name: 'home',
    component: () => import('@/views/app/public/home')
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('@/views/app/public/eCommerce/Checkout.vue'),
    meta: {
      pageTitle: 'Checkout',
      rule: 'editor'
    }
  },
  {
    path: '/home/sell',
    name: 'sell',
    component: () => import('@/views/app/public/housing/Sale.vue'),
    meta: {
      rule: 'admin'
    }
  },
  {
    path: '/home/sell/item/:item_id',
    name: 'houseSaleItemdetails',
    component: () => import('@/views/app/public/housing/houseSaleItemdetails.vue'),
    meta: {
      rule: 'admin'
    }
  },
  {
    path: '/home/rental',
    name: 'rental',
    component: () => import('@/views/app/public/housing/Rental.vue'),
    meta: {
      rule: 'admin'
    }
  },
  {
    path: '/home/rent/item/:item_id',
    name: 'houseRentItemdetails',
    component: () => import('@/views/app/public/housing/houseRentItemdetails.vue'),
    meta: {
      rule: 'admin'
    }
  },
  ...wishlist
         
  
]

